import { render, staticRenderFns } from "./_sales.vue?vue&type=template&id=d370d97e&scoped=true&"
import script from "./_sales.vue?vue&type=script&lang=js&"
export * from "./_sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d370d97e",
  null
  
)

export default component.exports